(function () {
  'use strict';

  const page = (window.FoxTheme && window.FoxTheme.page) || {};

  // Enhanced eCommerce tracking wrapper
  const EnhancedAnalytics = {
    // Track with neural model context
    trackEvent: function (category, action, label, value) {
      const ac = window.AgenticCommerce;
      const intent = ac ? sessionStorage.getItem('ac_intent') : null;

      // Add to dataLayer if GTM exists
      if (window.dataLayer) {
        window.dataLayer.push({
          event: category,
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          eventValue: value,
          userIntent: intent,
          pageSequence: ac ? ac.getPageSequence() : null,
        });
      }

      // Also track with GA4 if available
      if (window.gtag) {
        gtag('event', action, {
          event_category: category,
          event_label: label,
          value: value,
          user_intent: intent,
        });
      }
    },

    // Product impression tracking with AI context
    trackProductImpression: function (product, position, list) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'productImpression',
          ecommerce: {
            currencyCode: page.currency,
            impressions: [
              {
                name: product.name,
                id: product.id,
                price: product.price,
                brand: page.shopName,
                category: product.category,
                list: list,
                position: position,
              },
            ],
          },
          recommendationType: product.aiRecommended ? 'ai_powered' : 'manual',
        });
      }
    },

    // Track add to cart with intent
    trackAddToCart: function (product, quantity) {
      const intent = sessionStorage.getItem('ac_intent');

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            currencyCode: page.currency,
            add: {
              products: [
                {
                  name: product.name,
                  id: product.id,
                  price: product.price,
                  brand: page.shopName,
                  category: product.category,
                  quantity: quantity,
                },
              ],
            },
          },
          userIntent: intent,
          aiPredictedAction: 'add_to_cart',
        });
      }

      // Track revenue opportunity
      this.trackEvent('Commerce', 'Add to Cart', product.name, product.price * quantity);
    },

    // Track checkout steps with AI insights
    trackCheckoutStep: function (step, option) {
      const cartEvents = JSON.parse(sessionStorage.getItem('ac_cart_events') || '[]');
      const timeToCheckout =
        cartEvents.length > 0 ? (Date.now() - cartEvents[0].timestamp) / 1000 : 0;

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            checkout: {
              actionField: { step: step, option: option },
            },
          },
          timeToCheckout: timeToCheckout,
          cartActionCount: cartEvents.length,
        });
      }
    },

    // Track purchase with attribution
    trackPurchase: function (transaction) {
      const viewedProducts = JSON.parse(localStorage.getItem('ac_viewed_products') || '[]');
      const intent = sessionStorage.getItem('ac_intent');

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            purchase: {
              actionField: {
                id: transaction.id,
                affiliation: page.shopName,
                revenue: transaction.revenue,
                tax: transaction.tax,
                shipping: transaction.shipping,
                coupon: transaction.coupon,
              },
              products: transaction.products,
            },
          },
          productsViewedBeforePurchase: viewedProducts.length,
          finalIntent: intent,
          aiAssistedPurchase: true,
        });
      }
    },

    // Track recommendations performance
    trackRecommendationClick: function (productId, position, source) {
      this.trackEvent('Recommendations', 'Click', `${source}_position_${position}`, productId);

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'recommendationClick',
          productId: productId,
          position: position,
          source: source,
          modelId: 'model_1759421305895_digot6jhr',
        });
      }
    },

    // Track conversion optimization widgets
    trackCROWidget: function (widgetType, action) {
      this.trackEvent('CRO', action, widgetType, 1);

      // Track which widgets lead to conversions
      const croInteractions = JSON.parse(sessionStorage.getItem('cro_interactions') || '[]');
      croInteractions.push({
        widget: widgetType,
        action: action,
        timestamp: Date.now(),
      });
      sessionStorage.setItem('cro_interactions', JSON.stringify(croInteractions));
    },

    // Initialize all tracking
    init: function () {
      // Track page views with context
      this.trackEvent('Pageview', page.pageType, page.title, 1);

      // Listen for custom events from agentic commerce
      window.addEventListener('ac:product-viewed', (e) => {
        this.trackEvent('Product', 'View', e.detail.productTitle, e.detail.productId);
      });

      window.addEventListener('ac:recommendations-shown', (e) => {
        this.trackEvent('Recommendations', 'Shown', 'AI Powered', e.detail.products.length);
      });

      window.addEventListener('ac:exit-intent-shown', (e) => {
        this.trackEvent('Cart Recovery', 'Exit Intent Shown', 'Modal', e.detail.cartValue);
      });

      // Track social shares if they happen
      document.querySelectorAll('[data-share]')?.forEach((btn) => {
        btn.addEventListener('click', () => {
          const platform = btn.dataset.share;
          this.trackEvent('Social', 'Share', platform, 1);
        });
      });
    },
  };

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => EnhancedAnalytics.init());
  } else {
    EnhancedAnalytics.init();
  }

  // Make available globally
  window.EnhancedAnalytics = EnhancedAnalytics;
})();

(function () {
  'use strict';

  // Track Core Web Vitals for SEO
  function sendToAnalytics(metric) {
    if (window.gtag) {
      gtag('event', metric.name, {
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_category: 'Web Vitals',
        event_label: metric.id,
        non_interaction: true,
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'web_vitals',
        metric_name: metric.name,
        metric_value: metric.value,
        metric_id: metric.id,
        metric_delta: metric.delta,
      });
    }
  }

  // Load web-vitals library if needed
  if (typeof window.webVitals !== 'undefined') {
    window.webVitals.getCLS(sendToAnalytics);
    window.webVitals.getINP(sendToAnalytics); // UPDATED: INP replaced FID in March 2024
    window.webVitals.getLCP(sendToAnalytics);
    window.webVitals.getTTFB(sendToAnalytics); // ADDED: Time to First Byte (important for SEO)
    window.webVitals.getFCP(sendToAnalytics); // ADDED: First Contentful Paint (user experience)
  }
})();
